import React from 'react';
import PropTypes from 'prop-types';
import Table from 'components/Table/Table';
import { Grid, Typography } from '@material-ui/core';

export default function OrderProblemTable({ data, ...props }) {
  const columns = [
    {
      name: 'referenceId',
      label: '編號',
      options: {
        display: true,
        filter: false,
        sort: true,
      },
    },
    {
      name: 'warnings',
      label: '注意事項',
      options: {
        display: true,
        filter: false,
        sort: false,
        customBodyRender(value) {
          return (
            <Grid container direction='column'>
              {value.map((warning, index) => (
                <Typography key={index} variant='body2'>{warning}</Typography>
              ))}
            </Grid>
          );
        },
      },
    },
    {
      name: 'errors',
      label: '錯誤',
      options: {
        display: true,
        filter: false,
        sort: false,
        customBodyRender(value) {
          return (
            <Grid container direction='column'>
              {value.map((error, index) => (
                <Typography key={index} variant='body2' color='error'>{error}</Typography>
              ))}
            </Grid>
          );
        },
      },
    },
  ];

  return (
    <Table
      title={'訂單問題列表'}
      data={data}
      columns={columns}
      options={{
        selectableRows: 'none',
        rowsPerPage: 100,
      }}
      {...props}
    />
  );
}

OrderProblemTable.propTypes = {
  data: PropTypes.array.isRequired,
};
